<template>

  <div class="relative bg-white" >
    <div class="border-t border-gray-200 pt-10 pb-16 lg:py-10">
      <div class="max-w-6xl mx-auto px-4 sm:px-6">
        <div class="flex flex-wrap sm:flex-col lg:flex-row lg:space-y-0 sm:space-y-4">
          <div class="w-full lg:w-4/6 flex flex-col mb-2 lg:mb-0">
            <div class="flex sm:flex-col lg:flex-row justify-center lg:justify-start">
              <nav class="flex space-x-3">
                <a class="font-bold text-gray-400 hover:text-gray-700" href="#" title="">Donor Pledge</a>
                <a class="font-bold text-gray-400 hover:text-gray-700" href="#" title="">Disclaimer</a>
                <a class="font-bold text-gray-400 hover:text-gray-700" href="#" title="">Privacy Policy</a>
              </nav>
            </div>
            <p class="text-gray-400 text-sm text-center lg:text-left">&copy; {{currentYear}} Side-Out Foundation, a 501(c)(3) non-profit.</p>
          </div>
          <div class="w-full lg:w-2/6 flex flex-row items-center justify-center lg:justify-end lg:space-x-2 space-x-4 mt-2 lg:mt-0">
            <img class="block h-8 border border-gray-100 rounded px-3" src="/img/cloudflare.png" alt="Stripe">
            <img class="block h-8" src="/img/stripe.png" alt="Stripe">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from "moment";

  export default {
    name: 'DigPinkFooter',
    props: {
      date: null
    },
    computed: {
      currentYear() {
        return moment().year()
      }
    }
  }
</script>
